import { Injectable } from '@angular/core';
import {
  Http,
  Response,
  RequestOptions,
  Headers,
  Request,
  RequestMethod,
  RequestOptionsArgs,
  BaseRequestOptions,
  ResponseContentType
} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import 'rxjs/add/observable/throw';
import { URLSearchParams } from '@angular/http';
import { BaseUrl } from "../urls/base.url";
import { Notification } from "../../common/notification";
//import { HeaderComponent } from "../../components/header/header.component";
import { AuthHelper } from "../../common/auth.helper";
import { AppConstants } from '../../shared/constants/constants';
import { DialogService } from './dialog.service';
//import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SpinnerService } from '../../components/spinner/spinner.service';
import { AuthService } from './auth.service';
import { isArray } from 'util';
import { environment } from '../../../environments/environment';
import { Alert } from 'selenium-webdriver';

@Injectable()
export class BaseService {

  constructor(private http: Http,
    public dialogService: DialogService,
    private authService: AuthService,
    private spinnerService: SpinnerService
  ) {
  }

  public static get token(): string {
    let token = localStorage.getItem(AppConstants.localStorage.token);
    return token;
  }

  public static get centreId(): string {
    let centreId = localStorage.getItem(AppConstants.localStorage.centreId);
    return centreId;
  }


  create(url: string, data: any) {
    var headers = this.setHeaders();
    let options = new RequestOptions({
      method: RequestMethod.Post,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      body: JSON.stringify(data)
    });

    return this.execute(options);
  }

  update(url: string, data: any) {

    var headers = this.setHeaders();
    let options = new RequestOptions({
      method: RequestMethod.Put,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      body: JSON.stringify(data)
    });

    return this.execute(options);
  }

  postData(url: string, data: any) {
    var headers = this.setHeaders();
    //var isCheckLogout = (data['isCheckLogout'] != undefined && !data['isCheckLogout']) ? false : true;
    var isCheckLogout = true;
    if(url.concat('EmailConfirm'))
    {
      isCheckLogout = false;
    }
    let options = new RequestOptions({
      method: RequestMethod.Post,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      body: data
    });
    if(!isCheckLogout)
    {
      return this.execute(options,true, isCheckLogout);
    }
    else{
      return this.execute(options);
    }
  }

  downloadFile(url: string) {
    var headers = this.setHeaders();
    let options = new RequestOptions({
      method: RequestMethod.Get,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      responseType: ResponseContentType.Blob,
    });

    return this.execute(options);
  }

  remove(url: string, id: any, headers?: any) {
    let options = new RequestOptions({
      method: RequestMethod.Delete,
      url: BaseUrl.BASE_URL + url + '/' + id,
      headers: headers
    });

    return this.execute(options);
  }

  getAll(url: string) {
    var headers = this.setHeaders();

    let options = new RequestOptions({
      method: RequestMethod.Get,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
    });

    return this.execute(options);
  }

  getById(url: string, id: any) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('id', id);
    var headers = this.setHeaders();
    let options = new RequestOptions({
      method: RequestMethod.Get,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      search: params
    });

    return this.execute(options);
  }

  getData(url: string, data: any | URLSearchParams = null, showSpinner = true, isCheckLogout = true, isUpdateLastedDate = true): Observable<Response> {
    const headers = this.setHeaders();
    const params = new URLSearchParams();
    if (data) {
      if (data instanceof URLSearchParams) {
        params.setAll(data);
      }
      if (isArray(data)) {
        data.forEach(item => {
          for (const key in item) {
            if (item[key] != null && item[key] != undefined && item[key] != NaN && item.hasOwnProperty(key)) {
              let strParams = item[key].toString();
              if (params.has(key)) {
                params.append(key, strParams);
              } else {
                params.set(key, strParams);
              }
            }
          }
        });
      }
      else {
        for (const key in data) {
          if (data[key] != null && data[key] != undefined && data[key] != NaN && data.hasOwnProperty(key)) {
            //   if (data[key] && data[key].toString() === '*') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('*', '%2A'));
            //   } else if (data[key] && data[key].toString() === '!') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('!', '%21'));
            //   } else if (data[key] && data[key].toString() === '~') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('~', '%7E'));
            //   } else if (data[key] && data[key].toString() === '(') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('(', '%28'));
            //   } else if (data[key] && data[key].toString() === ')') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace(')', '%29'));
            //   } else if (data[key] && data[key].toString() === '\'') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('\'', '%27'));
            //   } else if (data[key] && data[key].toString() === '#') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('#', '%23'));
            //   } else {
            //     params.set(key, encodeURIComponent(data[key]));
            //   }
            //let strParams = encodeURIComponent(data[key]).toString();
            // strParams = strParams.replace('(', '%28');
            // strParams = strParams.replace(')', '%29');
            let strParams = data[key].toString();
            params.set(key, strParams);
          }
        }
      }
    }

    const options = new RequestOptions({
      params: params,
      method: RequestMethod.Get,
      url: BaseUrl.BASE_URL + url,
      headers: headers
    });

    return this.execute(options, showSpinner, isCheckLogout, isUpdateLastedDate);
  }

  get(url: string, options?: RequestOptionsArgs, isBaseUrl = true): Observable<Response> {

    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }

    reqOpts.method = RequestMethod.Get;
    reqOpts.url = isBaseUrl ? (BaseUrl.BASE_URL + url) : url;

    return this.execute(reqOpts);
  }

  post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }

    reqOpts.method = RequestMethod.Post;
    reqOpts.url = BaseUrl.BASE_URL + url;
    reqOpts.body = body;

    return this.execute(reqOpts);
  }

  put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }


    reqOpts.method = RequestMethod.Put;
    reqOpts.url = BaseUrl.BASE_URL + url;
    reqOpts.body = body;

    return this.execute(reqOpts);
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};
    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }

    reqOpts.method = RequestMethod.Delete;
    reqOpts.url = BaseUrl.BASE_URL + url;

    return this.execute(reqOpts);
  }

  upload(url: string, data: any) {
    const headers = this.setHeadersForUpLoadFile();
    const options = new RequestOptions({
      method: RequestMethod.Post,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      body: data
    });
    return this.execute(options);
  }

  export(url: string) {
    const headers = this.setHeaders();
    const options = new RequestOptions({
      method: RequestMethod.Get,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      responseType : 3
    });
    return this.execute(options);
  }

  patch(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }

    reqOpts.method = RequestMethod.Patch;
    reqOpts.url = BaseUrl.BASE_URL + url;
    reqOpts.body = body;

    return this.execute(reqOpts);
  }

  head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }
    reqOpts.method = RequestMethod.Head;
    reqOpts.url = BaseUrl.BASE_URL + url;
    return this.execute(reqOpts);
  }


  private execute(options: any, showSpinner = true, isCheckLogout = true, isUpdateLastedDate = true) {
    // noinspection TypeScriptUnresolvedFunction
    const currentDate = new Date();
    const currentTime = currentDate.valueOf();
    const lastAccessDate = new Date(localStorage.getItem(AppConstants.localStorage.lastAccessDate));
    const sessionTime =  lastAccessDate.setSeconds(lastAccessDate.getSeconds() + environment.sessionExpiredDuration);

    if (sessionTime > currentTime) {
      if (isUpdateLastedDate) {
        localStorage.setItem(AppConstants.localStorage.lastAccessDate, currentDate.toString());
        const exDate = new Date(sessionTime);
        localStorage.setItem(AppConstants.localStorage.expireDate,exDate.toString());
      }
    }
    else if (isCheckLogout) {
      console.log('current time is '+ currentTime +', sessiontime is '+ sessionTime + ',lastAccessDate is '
      + lastAccessDate +' isCheckLogout and call logout function: ', );
      this.logout();
    }

    // const lastAccessDate = new Date();
    if (showSpinner) {
      this.spinnerService.show();
    }
    return this.http.request(new Request(options)).catch(
      error => {
        console.log("execute error");
        let errMsg = 'error';
        if (error.status === 401 && error.statusText === 'Unauthorized') {
          console.log('get refresh token');
          this.refreshToken();
          return Observable.throw('no error');
        } else if (error.status === 403) {
          // Notification.notify(null, 'danger', 'Do not have permission to edit this item.');
        } else if (error.status === 500 || error.status === 400) {
          let errMsg = error.json();
          this.dialogService.openErrorDialog({ message: errMsg.message });
        } else {
          let errMsg = error.json();
          console.log(errMsg);
        }
        //Notification.notify($('main-app'), 'danger', error);
        return Observable.throw(error);
      }).finally(
        () => {
          this.spinnerService.hide();
        });
  }
  
  private refreshToken() {
    var that = this;
    let refresh_token = localStorage.getItem("refresh_token");
    let access_token = localStorage.getItem("access_token");
    let username = localStorage.getItem("access_username");
    AuthHelper.resetLocalStorage();
    window.location.href = '/landing';
    //return Observable.throw('');

    /*
     if(refresh_token === null || access_token === null || username === null){
     AuthHelper.reset();
     window.location.href = '/';
     return Observable.throw('');
     //this._router.navigate(['/login']);
     } else {
     let credentials =`grant_type=refresh_token&refresh_token=${refresh_token}&token_type=bearer`;

     let headers = new Headers();
     headers.append('Content-Type', 'application/x-www-form-urlencoded');

     let result = this.http.post( `${BaseUrl.BASE_URL}/token`, credentials, { headers: headers} );
     result.subscribe(
     (result) => {
     let profile = result.json();
     localStorage.setItem('profile', JSON.stringify(result));
     localStorage.setItem('access_token', profile["access_token"]);
     localStorage.setItem('access_username', profile["userName"]);
     localStorage.setItem('access_avatarUrl', profile["avatarUrl"]);
     localStorage.setItem('access_expire', profile[".expire"]);
     localStorage.setItem('refresh_token', profile["refresh_token"]);

     var token = localStorage.getItem('access_token');

     },
     error => {
     console.log(error);
     return Observable.throw(error);
     });
     }
     */
  }

  public setHeaders(header?: Headers) {
    let authHeaders;
    if (!header) {
      authHeaders = new Headers();
    }

    authHeaders.append('Content-Type', 'application/json; charset=utf-8');
    authHeaders.append('Accept', 'application/json');
    authHeaders.append('Authorization', 'bearer ' + BaseService.token);
    authHeaders.append('TimezoneOffsetUtcLocal', new Date().getTimezoneOffset());
    if (BaseService.centreId) {
      authHeaders.append('SelectedCentreId', BaseService.centreId);
    }
    return authHeaders;
  }

  public setHeadersForUpLoadFile(header?: Headers) {
    let authHeaders;
    if (!header) {
      authHeaders = new Headers();
    }

    authHeaders.append('Authorization', 'bearer ' + BaseService.token);
    // authHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    if (BaseService.centreId) {
      authHeaders.append('SelectedCentreId', BaseService.centreId);
    }
    return authHeaders;
  }

  public logout() {
    this.authService.logout();
    this.setDataEntry(null, null);
  }

  public authenticateReportSite(reportServiceUrl: string, clientId: string): Observable<Response> {
    const reqOpts = {
      headers: this.setAuthenticateReportHeaders(clientId),
      method: RequestMethod.Post,
      url: reportServiceUrl + '/Authenticate'
    };
    return this.execute(reqOpts);
  }

  private setAuthenticateReportHeaders(clientId: string) {
    let authHeaders;
    authHeaders = new Headers();

    authHeaders.append('Content-Type', 'application/json; charset=utf-8');
    authHeaders.append('Accept', 'application/json');
    authHeaders.append('Authorization', 'bearer ' + BaseService.token);
    authHeaders.append('client_id', clientId);

    return authHeaders;
  }

  public setDataEntry(deUserName, deUserId) {
    // reset data entry info
    localStorage.setItem(AppConstants.localStorage.deUserName, deUserName);
    localStorage.setItem(AppConstants.localStorage.deUserId, deUserId);
  }

  public getBuildVersion() {
    return this.getData('/build-version', null, true, false);
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/services/base.service.ts